import React from 'react';
import 'ui-toolkit/scss/modules/_ordered-items.scss';
import Currency from './Currency';
import styled from 'styled-components';
import NoPermissionsErrorMessage from '../shared/permissions/NoPermissionsErrorMessage';

export interface ICostTitle {
  name: string;
  showLenderPaid?: boolean;
  showSeller?: boolean;
  buyerValue: number;
  sellerValue?: number;
  otherValue: number;
  hasEditPermissions?: boolean;
}

interface IStyledGridLabelProps {
  gridArea: string;
}
const StyledWithGridArea = styled.div<IStyledGridLabelProps>`
  grid-area: ${(props) => props.gridArea};
`;
const StyledGridLabel = styled(StyledWithGridArea)`
  font-size: 9px;
  padding: 0 8px;
  text-align: right;
  text-transform: uppercase;
`;

const StyledGridValue = styled(StyledWithGridArea)`
  text-align: right;
  padding: 0 8px;
`;

interface IStyledCostTitleProps {
  showLenderPaid?: boolean;
  showSeller: boolean;
}

const nameCellWidth = '1fr';
const columnWidth = 120;
const narrowColumnWidth = '60px';
const wideColumnWidth = '180px';

const StyledCostTitle = styled.div<IStyledCostTitleProps>`
  ${(props) => props.theme.fonts.mixins.boldHeader3}
  display: grid;
  grid-template-columns: ${(props) =>
    `${nameCellWidth} repeat(${props.showSeller ? '2' : '1'}, ${
      columnWidth * 2
    }px) ${columnWidth}px ${narrowColumnWidth} ${wideColumnWidth} ${narrowColumnWidth}`};
  grid-template-areas: ${(props) =>
    `'empty buyerlabel ${props.showSeller ? 'sellerlabel' : ''} otherlabel control control control'
     'label buyervalue ${props.showSeller ? 'sellervalue' : ''} othervalue control control control'`};
  justify-content: space-between;
`;

const StyledCostTitleLabel = styled.div`
  display: inline-block;
  gap: 4px;
  grid-area: label;
  grid-auto-flow: column;
  grid-template-columns: max-content;
  text-align: left;
`;

//, fontWeight: 'normal', marginLeft: '.5rem', fontSize: '16px' }
export default class CostTitle extends React.Component<ICostTitle> {
  public render() {
    const { buyerValue, name, otherValue, sellerValue, showLenderPaid, showSeller, hasEditPermissions } = this.props;
    return (
      <StyledCostTitle showSeller={!!showSeller} showLenderPaid={showLenderPaid}>
        <StyledGridLabel gridArea={'buyerlabel'}>{showSeller ? 'Buyer' : 'Borrower'}-paid</StyledGridLabel>
        {showSeller ? <StyledGridLabel gridArea={'sellerlabel'}>Seller-paid</StyledGridLabel> : ''}
        <StyledGridLabel gridArea={'otherlabel'}>Paid by others</StyledGridLabel>
        <StyledCostTitleLabel>
          {name} &nbsp;
          <NoPermissionsErrorMessage hasPermissions={hasEditPermissions} />
        </StyledCostTitleLabel>
        <StyledGridValue gridArea={`buyervalue`}>
          <Currency value={buyerValue} />
        </StyledGridValue>
        {showSeller ? (
          <StyledGridValue gridArea={`sellervalue`}>
            <Currency value={sellerValue} />
          </StyledGridValue>
        ) : (
          ''
        )}
        <StyledGridValue gridArea={`othervalue`}>
          <Currency value={otherValue} />
        </StyledGridValue>
      </StyledCostTitle>
    );
  }
}
